"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Loading_1 = __importDefault(require("components/Loading"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var add_photo_icon_yellow_svg_1 = __importDefault(require("res/img/add-photo-icon-yellow.svg"));
var help_icon_svg_1 = __importDefault(require("res/img/help-icon.svg"));
var mobx_1 = require("mobx");
var EditProductGallery = function (_a) {
    var images = _a.images, onDelete = _a.onDelete, onChangeOrder = _a.onChangeOrder, onUpload = _a.onUpload, busy = _a.busy;
    var _b = react_1.useState(images), data = _b[0], setData = _b[1];
    var _c = react_1.useState(images.length > 0 && images[0] || null), active = _c[0], setActive = _c[1];
    var _d = react_1.useState(false), mouseDown = _d[0], setMouseDown = _d[1];
    var wrapperRef = react_1.useRef(null);
    var mouseDownRef = react_1.useRef(null);
    var mouseMoveRef = react_1.useRef({ x: 0, y: 0 });
    var grabbedDataRef = react_1.useRef(null);
    var grabbedRef = react_1.useRef(null);
    var animationFrameRef = react_1.useRef(0);
    var divRefs = react_1.useRef(images.map(function () { return react_1.default.createRef(); }));
    var cloneRefs = react_1.useRef(images.map(function () { return react_1.default.createRef(); }));
    var imagesRef = react_1.useRef(data);
    var dataRef = react_1.useRef(data);
    var downRef = react_1.useRef({ x: 0, y: 0 });
    var goingRef = react_1.useRef(false);
    react_1.useEffect(function () {
        animationFrameRef.current = requestAnimationFrame(animationFrame);
        return function () {
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);
    react_1.useEffect(function () {
        setData(images);
        imagesRef.current = images;
        var foundActive = 0;
        console.log(mobx_1.toJS(images));
        if (active) {
            for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
                var image = images_1[_i];
                if (image.id === active.id)
                    foundActive++;
            }
        }
        if (!foundActive) {
            setActive(images.length > 0 && images[0] || null);
        }
        divRefs.current = images.map(function () { return react_1.default.createRef(); });
        cloneRefs.current = images.map(function () { return react_1.default.createRef(); });
    }, [images]);
    react_1.useEffect(function () {
        dataRef.current = data;
    }, [data]);
    var deleteHandler = function () {
        onDelete(active);
    };
    var clickHandler = function (image) {
        setActive(image);
    };
    var mouseDownHandler = function (e) {
        var clone = e.currentTarget.cloneNode(true);
        clone.style.width = e.currentTarget.clientWidth + 'px';
        clone.style.height = e.currentTarget.clientHeight + 'px';
        clone.style.position = 'fixed';
        clone.style.top = '0';
        clone.style.left = '0';
        clone.style.zIndex = '900000';
        clone.style.pointerEvents = 'none';
        clone.style.opacity = '0';
        grabbedRef.current = clone;
        for (var _i = 0, images_2 = images; _i < images_2.length; _i++) {
            var image = images_2[_i];
            if (image.id === parseInt(e.currentTarget.dataset.id)) {
                grabbedDataRef.current = image;
            }
        }
        document.body.appendChild(grabbedRef.current);
        mouseDownRef.current = true;
        downRef.current = { x: e.pageX, y: e.pageY };
        setMouseDown(true);
    };
    var mouseUpHandler = function (e) {
        if (!goingRef.current) {
            var elementTarget = e.target;
            var id = elementTarget.dataset.id;
            if (typeof id !== 'undefined' && id.length >= 1) {
                for (var _i = 0, images_3 = images; _i < images_3.length; _i++) {
                    var image = images_3[_i];
                    if (image.id === parseInt(id)) {
                        setActive(image);
                    }
                }
            }
        }
        destroyGrabbed();
    };
    var destroyGrabbed = function () {
        mouseDownRef.current = false;
        setMouseDown(false);
        if (grabbedRef.current !== null) {
            document.body.removeChild(grabbedRef.current);
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var image = data_1[_i];
                if (image.id === grabbedDataRef.current.id) {
                    if (image.displayOrder !== grabbedDataRef.current.displayOrder) {
                        onChangeOrder(data);
                    }
                    break;
                }
            }
        }
        goingRef.current = false;
        grabbedRef.current = null;
        mouseDownRef.current = false;
    };
    var mouseMoveHandler = function (e) {
        mouseMoveRef.current = { x: e.pageX, y: e.pageY };
    };
    var animationFrame = function (time) {
        if (mouseDownRef.current && grabbedRef.current !== null) {
            var startPos = downRef.current;
            var mousePos = mouseMoveRef.current;
            if (Math.abs(mousePos.x - startPos.x) > 20 ||
                Math.abs(mousePos.y - startPos.y) > 20) {
                goingRef.current = true;
            }
            if (goingRef.current) {
                var grabbed = grabbedRef.current;
                var halfWidth = grabbed.clientWidth >> 1;
                var halfHeight = grabbed.clientHeight >> 1;
                grabbed.style.opacity = '1';
                grabbed.style.transform = "translate(" + (mousePos.x - halfWidth) + "px, " + (mousePos.y - halfHeight) + "px)";
                var grabbingId_1 = parseInt(grabbed.dataset.id);
                for (var _i = 0, _a = divRefs.current; _i < _a.length; _i++) {
                    var div = _a[_i];
                    var bounds = div.current.getBoundingClientRect();
                    if (mousePos.x > bounds.left && mousePos.x < bounds.left + bounds.width &&
                        mousePos.y > bounds.top && mousePos.y < bounds.top + bounds.height) {
                        var divId = parseInt(div.current.dataset.id);
                        var _loop_1 = function (hoveringImage) {
                            if (hoveringImage.id === divId) {
                                var originalPosition_1 = grabbedDataRef.current.displayOrder;
                                var newPosition_1 = hoveringImage.displayOrder;
                                var newData = imagesRef.current.map(function (item) {
                                    if (item.id === grabbingId_1) {
                                        return __assign(__assign({}, item), { displayOrder: newPosition_1 });
                                    }
                                    if (newPosition_1 < originalPosition_1) {
                                        if (item.displayOrder >= newPosition_1 && item.displayOrder < originalPosition_1) {
                                            return __assign(__assign({}, item), { displayOrder: item.displayOrder + 1 });
                                        }
                                    }
                                    if (newPosition_1 > originalPosition_1) {
                                        if (item.displayOrder <= newPosition_1 && item.displayOrder > originalPosition_1) {
                                            return __assign(__assign({}, item), { displayOrder: item.displayOrder - 1 });
                                        }
                                    }
                                    return __assign({}, item);
                                });
                                setData(newData);
                            }
                        };
                        for (var _b = 0, _c = imagesRef.current; _b < _c.length; _b++) {
                            var hoveringImage = _c[_b];
                            _loop_1(hoveringImage);
                        }
                    }
                }
            }
        }
        animationFrameRef.current = requestAnimationFrame(animationFrame);
    };
    var compare = function (a, b) {
        if (a.displayOrder < b.displayOrder)
            return -1;
        if (a.displayOrder > b.displayOrder)
            return 1;
        return 0;
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-gallery' },
        react_1.default.createElement("span", { className: 'title' }, "Product Images"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null, "Upload or delete product images. Drag and drop image thumbnails to reorder images.")),
        react_1.default.createElement("div", { className: 'edit-product-gallery__content' },
            react_1.default.createElement("div", { className: 'edit-product-gallery__active', "data-null": !active },
                active !== null &&
                    react_1.default.createElement("div", { className: 'edit-product-gallery__active__img', "data-id": active && active.id },
                        react_1.default.createElement("img", { src: active && active.filepath, alt: 'Active Image' })),
                active !== null &&
                    react_1.default.createElement("button", { type: 'button', "aria-label": 'Delete Image', onClick: deleteHandler, className: 'flex flex-column flex-center', title: 'Delete Image' },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Delete' }))),
            react_1.default.createElement("div", { className: 'edit-product-gallery__thumbs thin-scroll flex flex-column', ref: wrapperRef, onMouseMove: mouseMoveHandler, onMouseUp: mouseUpHandler, "data-grabbing": goingRef.current },
                react_1.default.createElement("div", { className: 'edit-product-gallery__upload' },
                    react_1.default.createElement("div", { className: 'edit-product-gallery__upload__img flex flex-column flex-center' }, busy ? react_1.default.createElement(Loading_1.default, null) : react_1.default.createElement("img", { src: add_photo_icon_yellow_svg_1.default, alt: 'Add Photo' })),
                    react_1.default.createElement("input", { type: 'file', name: 'image', accept: 'image/jpg, image/jpeg, image/png, image/bmp, image/webp', multiple: true, onChange: onUpload })),
                images.slice().sort(compare).map(function (image, i) { return (react_1.default.createElement("div", { ref: divRefs.current[i], key: image.id, "data-id": image.id, className: 'edit-product-gallery__thumb', onMouseDown: mouseDownHandler, onClick: function () { return clickHandler(image); }, "data-order": image.displayOrder, "aria-selected": active && active.id === image.id, "data-grabbed": grabbedRef.current !== null &&
                        parseInt(grabbedRef.current.dataset.id) === image.id },
                    react_1.default.createElement("div", { className: 'edit-product-gallery__thumb__img' },
                        react_1.default.createElement("img", { src: image.thumbnail, alt: 'Image Thumbnail' })))); }),
                mouseDown &&
                    react_1.default.createElement("div", { className: 'edit-product-gallery__clones thin-scroll flex flex-column' },
                        react_1.default.createElement("div", { className: 'empty-spacer' },
                            react_1.default.createElement("div", { className: 'empty-space-img' }, "\u00A0")),
                        data.slice().sort(compare).map(function (image, i) { return (react_1.default.createElement("div", { ref: cloneRefs.current[i], key: image.id, "data-id": image.id, className: 'edit-product-gallery__thumb', onMouseDown: mouseDownHandler, "data-order": image.displayOrder, "data-grabbed": grabbedRef.current !== null &&
                                parseInt(grabbedRef.current.dataset.id) === image.id },
                            react_1.default.createElement("div", { className: 'edit-product-gallery__thumb__img' },
                                react_1.default.createElement("img", { src: image.thumbnail, alt: 'Image Thumbnail' })))); }))))));
};
exports.default = EditProductGallery;
